import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportMemberRegistrationPageRoutingModule } from './report-member-registration-routing.module';

import { ReportMemberRegistrationPage } from './report-member-registration.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportMemberRegistrationPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [ReportMemberRegistrationPage]
})
export class ReportMemberRegistrationPageModule {}
